const multiColumnATC = () => {
    document.querySelectorAll('.column__btn .btn__atc').forEach(button => {
        button.addEventListener('click', function () {
            const url = this.getAttribute('data-url');
            const [path, query] = url.split('?');
            const [variantData] = path.split('/cart/').slice(1);
            const [variantId, quantity] = variantData.split(':');
            const params = new URLSearchParams(query);
            const discount = params.get('discount');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: parseInt(quantity, 10),
                }),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart');
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
            })
            .catch(error => {
                console.error(error);
            });
        });
    });
}
if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        multiColumnATC();
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-columns')) {
        multiColumnATC();
    }
});

if(document.querySelector("#all-natural-skincare-starter-set")) {
    setTimeout(() => {
        // Code to be executed after 2 seconds
        document.querySelector("#all-natural-skincare-starter-set .skincare-starter-set-4oz").remove();
    }, 2000);
}


// Custom product slider
function customProductSlider() {
    const productSectionWrapper = document.querySelector('.index-product .product__wrapper');
    if (productSectionWrapper && productSectionWrapper.classList.contains('product__wrapper--thumbnails')) {
        document.body.style.overflowX = 'hidden';
    }
}

// Upsell block custom variant dropdown select
class ExpandDropdown {
    constructor() {
        this.filterDropdowns = document.querySelectorAll('.prod-upsell__variants');
        this.activeMenu = null;
        this.init();
    }

    init() {
        if (this.filterDropdowns.length === 0) return;
        this.bindEvents();
    }

    bindEvents() {
        this.filterDropdowns.forEach(dropdown => {
            const btn = dropdown.querySelector('[data-variants-toggle]');
            const btnText = dropdown.querySelector('[data-variants-toggle] span');
            const filterMenu = dropdown.querySelector('.prod-upsell__variant-options');
            const options = dropdown.querySelectorAll('.prod-upsell__option');

            if (btn && filterMenu) {
                btn.addEventListener('click', (event) => this.toggleMenu(event, filterMenu));
            }

            options.forEach(option => {
                option.addEventListener('click', (event) => this.selectVariant(event, btnText, filterMenu, options));
            });
        });
        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    toggleMenu(event, filterMenu) {
        event.stopPropagation();
        if (this.activeMenu && this.activeMenu !== filterMenu) {
            this.activeMenu.classList.remove('dropdown-open');
        }
        if (filterMenu.classList.contains('dropdown-open')) {
            filterMenu.classList.remove('dropdown-open');
            this.activeMenu = null;
        } else {
            filterMenu.classList.add('dropdown-open');
            this.activeMenu = filterMenu;
        }
    }

    selectVariant(event, btnText, filterMenu, options) {
        const selectedOption = event.target.closest('.prod-upsell__option');
        const selectedTitle = selectedOption.getAttribute('data-variant-title');
        btnText.innerText = selectedTitle;
        options.forEach(option => option.classList.remove('active-prod-selection'));
        selectedOption.classList.add('active-prod-selection');
        filterMenu.classList.remove('dropdown-open');
        this.activeMenu = null;
    }

    handleOutsideClick(event) {
        if (this.activeMenu && !event.target.closest('[data-variants-toggle]')) {
            this.activeMenu.classList.remove('dropdown-open');
            this.activeMenu = null;
        }
    }
}

// Tabs toggle
const tabsToggle = () => {
    const tabCtrs = document.querySelectorAll('.column-item__content-tabs');
    tabCtrs.forEach(ctr => {
        const tabs = ctr.querySelectorAll('.column-item__tab');
        const tabsBody = ctr.querySelectorAll('.column-item__body');
        if(tabs[0]) {
            tabs[0].classList.add('tab-active');
        }
        if(tabsBody[0]) {
            tabsBody[0].classList.add('tab-active');
        }
        function activeClass(tabId) {
            tabsBody.forEach(body => {
                if (body.getAttribute('data-tab-id') === tabId) {
                    body.classList.add('tab-active');
                } else {
                    body.classList.remove('tab-active');
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-tab-id') === tabId) {
                    tab.classList.add('tab-active');
                } else {
                    tab.classList.remove('tab-active');
                }
            });
        }
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabId = event.currentTarget.getAttribute('data-tab-id');
                activeClass(tabId);
            });
        });
    });
};

document.addEventListener('shopify:section:load', () => {
    customProductSlider();
    new ExpandDropdown();
    tabsToggle();
});
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.index-product__custom-layout')) {
        customProductSlider();
    }
    if(document.querySelector('.product__upsell--custom')) {
        new ExpandDropdown();
        tabsToggle();
    }
});

// Afterpay move
document.addEventListener("DOMContentLoaded", function () {
    const observerTarget = document.body;

    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const squarePlacement = document.querySelector("square-placement");
                const submitButtons = document.querySelector(".product__submit__buttons");

                if (squarePlacement && submitButtons) {
                    squarePlacement.remove();
                    submitButtons.insertAdjacentElement("afterend", squarePlacement);
                    observer.disconnect();
                    break;
                }
            }
        }
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
});

function formatProductPrice() {
    const priceElements = document.querySelectorAll('.index-product .product__price [data-product-price]');
    
    function formatPrice(priceElement) {
        const price = priceElement.innerHTML;
        if (price) {
            const formattedPrice = price.replace(/\.\d+$/, '');
            if (priceElement.innerHTML !== formattedPrice) {
                priceElement.innerHTML = formattedPrice;
            }
            
            const strikeThroughPrice = priceElement.querySelector('s');
            if (strikeThroughPrice) {
                const formattedStrikePrice = strikeThroughPrice.innerHTML.replace(/\.\d+$/, '');
                if (strikeThroughPrice.innerHTML !== formattedStrikePrice) {
                    strikeThroughPrice.innerHTML = formattedStrikePrice;
                }
            }
        }
    }

    if (priceElements.length > 0) {
        priceElements.forEach(formatPrice);
    }

    const observerPrice = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
                const currentPriceElements = document.querySelectorAll('.index-product .product__price [data-product-price]');
                currentPriceElements.forEach(formatPrice);
            }
        }
    });

    const container = document.querySelector('.index-product') || document.body;
    observerPrice.observe(container, { 
        childList: true, 
        subtree: true, 
        characterData: true 
    });
    
    return observerPrice;
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.index-product')) {
        formatProductPrice();
    }
});
document.addEventListener('shopify:section:load', () => {
    formatProductPrice();
});

// Afterpay styling
function applyAfterpayStyles() {
    const afterpayElement = document.querySelector('square-placement');
    if (afterpayElement && afterpayElement.shadowRoot) {
        const shadowRoot = afterpayElement.shadowRoot;
        if (shadowRoot.querySelector('.afterpay-paragraph')) {
            const style = document.createElement('style');
            style.textContent = `
                .afterpay-paragraph { 
                    margin-right: -25px !important;
                }
                .afterpay-paragraph .afterpay-main-text { 
                    color: #494541 !important;
                    font-size: 12px !important;
                    font-weight: 400 !important;
                    line-height: 200% !important;
                }
                .afterpay-paragraph strong {
                    font-weight: 400 !important;
                }
                .afterpay-paragraph .afterpay-link {
                    display: none !important;    
                }
                .afterpay-paragraph svg {
                    margin-left: -55px;
                }
                .afterpay-paragraph svg g path:nth-of-type(1),
                .afterpay-paragraph svg g path:nth-of-type(2) {
                    display: none !important;
                }
            `;
            shadowRoot.appendChild(style);
        }
    }
}

function observeAfterpayElement() {
        const afterpayObserver = new MutationObserver((mutationsList, observer) => {
            const afterpayElement = document.querySelector('square-placement');
            if (afterpayElement && afterpayElement.shadowRoot) {
                const shadowRoot = afterpayElement.shadowRoot;
                if (shadowRoot.querySelector('.afterpay-paragraph')) {
                    applyAfterpayStyles();
                }
            }
        });
        afterpayObserver.observe(document.body, { childList: true, subtree: true });
        const placementObserver = new MutationObserver(() => {
            const afterpayElement = document.querySelector('square-placement');
            if (afterpayElement && afterpayElement.shadowRoot) {
                const shadowRoot = afterpayElement.shadowRoot;
                if (shadowRoot.querySelector('.afterpay-paragraph')) {
                    applyAfterpayStyles();
                }
            }
        });
        placementObserver.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.index-product')) {
        observeAfterpayElement();
    }
});

const hideAfterPay = () => {
    const rechargeBtns = document.querySelectorAll('.rtx-purchase-label');
    console.log(rechargeBtns)
    rechargeBtns.forEach((btn, index) => {
        if(index === 1) {
            btn.addEventListener('click', () => {
                document.querySelector('square-placement').classList.add('hide-square-placement')
            })
        }
        if(index === 0) {
            btn.addEventListener('click', () => {
                document.querySelector('square-placement').classList.remove('hide-square-placement')
            })
        }
    })
}
// hideAfterPay();

// Script for collection sidebar nav dropdown
const collectionSidebarNav = () => {
    const sidebarLinkList = document.querySelectorAll('.sidebar__item--linklist');
    sidebarLinkList.forEach(list => {
        const parent = list.querySelector('.parent-link');
        const dropdown = list.querySelector('.sidebar__item--dropdown');

        if(list.getAttribute('data-list-open') === "true") {
            dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;
        }

        if (!parent) return;

        if (parent.dataset.listenerAdded === "true") return;

        parent.addEventListener('click', (e) => {
            let dataOpen = list.getAttribute('data-list-open');
            if (dataOpen === 'true') {
                list.setAttribute('data-list-open', 'false');
                dropdown.style.maxHeight = '0';
            } else {
                list.setAttribute('data-list-open', 'true');
                dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;
            }
        });

        parent.dataset.listenerAdded = "true";
    });
};

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.filter-group--nav')) {
        collectionSidebarNav();
    }
});

document.addEventListener('shopify:section:load', function () {
    collectionSidebarNav();
});

document.addEventListener('theme:filter:update', function () {
    collectionSidebarNav();
});

// Promo block height
function setHeightPromoBlocks() {
    const prodGridItems = document.querySelectorAll('.collection .product-item:not(.product-item.product-item--featured-image-double)');
    const promoBlocks = document.querySelectorAll('.collection .product-item.product-item--featured-image-double');

    if(promoBlocks.length === 0) return;

    let maxHeight = 0;
    prodGridItems.forEach(item => {
        item.style.height = 'auto';
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
        }
    })
    promoBlocks.forEach(item => {
        item.style.height = `${maxHeight}px`;
    })
}
function checkHeightGridItems () {
    const promoBlocks = document.querySelectorAll('.collection .product-item.product-item--featured-image-double');
    if (window.innerWidth <= 989) {
        setHeightPromoBlocks();
    } else {
        promoBlocks.forEach(item => {
            item.style.height = 'auto';
        })
    }
}
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.collection')) {
        checkHeightGridItems();
        window.addEventListener('resize', checkHeightGridItems);
    }
});
document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('.collection')) {
        checkHeightGridItems();
        window.addEventListener('resize', checkHeightGridItems);
    }
});

  const reviewsDiv = document.querySelector(".yotpo-sr-bottom-line-text");
  if (reviewsDiv) {
    reviewsDiv.innerHTML = reviewsDiv.innerHTML.replace(/Reviews/gi, "").trim();
  }


// Variant image and thumbnail select on page load
function selectImage() {
    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return;

    const thumbs = document.querySelectorAll('.product__thumb');
    thumbs.forEach(thumb => thumb.classList.remove('is-active'));

    const productData = document.querySelector('[data-product-json]')?.textContent;
    if (!productData) return;

    const product = JSON.parse(productData);
    const variant = product.variants.find(v => v.id == variantId);
    const mediaId = variant?.featured_media?.id;
    
    if (mediaId) {
        const activeThumb = document.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.querySelector('a')?.click();
        }
    }
}

function waitForSelectedSlide() {
    const slides = document.querySelectorAll('.product__slide');
    if (!slides.length) return;

    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.type === 'attributes' && 
                mutation.attributeName === 'class' && 
                mutation.target.classList.contains('is-selected')) {
                
                mutation.target.classList.remove('is-selected');
                observer.disconnect();
                selectImage();
                return;
            }
        }
    });

    slides.forEach(slide => {
        observer.observe(slide, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
}

if (document.querySelector('.index-product__custom-layout')) {
    waitForSelectedSlide();
}

// Discount product price logic
const initializeDiscountLogic = (container, productTitle) => {
    if(!theme.settings.enablePriceDiscount) return;
    if(!container || !productTitle) return;
    
    if(container.dataset.discountInitialized) return;
    container.dataset.discountInitialized = 'true';

    const excludeArr = theme.settings.excludeFromDiscount.split(',').map(title => title.toLowerCase().trim());
    
    let enableDiscountLogic = true;
    excludeArr.forEach(prod => {
        if(prod === productTitle.toLowerCase().trim()) {
            enableDiscountLogic = false;
        };
    })
    
    if(enableDiscountLogic) {
        // const rtxSubWidget = container.querySelector('.rtx-subscription__widget');
        // if(rtxSubWidget) {
        //     const subOneTimeBtn = rtxSubWidget.querySelector('.rtx-purchase-label--one-time');
        //     const subBtn = rtxSubWidget.querySelector('.rtx-purchase-label--subscription');
        //     const pdpDiscountWrapper = container.querySelectorAll('[data-pdp-discount-wrapper]:not(.rtx-subscription [data-pdp-discount-wrapper])');
        //     const dataPriceEl = container.querySelectorAll('[data-product-price-custom]');

        //     if(!subBtn?.dataset.listenerAdded) {
        //         subBtn.addEventListener('click', () => {
        //             pdpDiscountWrapper.forEach(wrapper => {
        //                 wrapper.style.display = 'none';
        //             })
        //             dataPriceEl.forEach(el => {
        //                 el.style.visibility = 'visible';
        //                 el.style.width = 'auto';
        //                 el.style.height = 'auto';
        //             })
        //         });
        //         subBtn.dataset.listenerAdded = 'true';
        //     }

        //     if(!subOneTimeBtn?.dataset.listenerAdded) {
        //         subOneTimeBtn.addEventListener('click', () => {
        //             pdpDiscountWrapper.forEach(wrapper => {
        //                 wrapper.style.display = 'flex';
        //             })
        //             dataPriceEl.forEach(el => {
        //                 el.style.visibility = 'hidden';
        //                 el.style.width = '0';
        //                 el.style.height = '0';
        //             })
        //         });
        //         subOneTimeBtn.dataset.listenerAdded = 'true';
        //     }
        // }

        if(!container.dataset.variantListenerAdded) {
            container.addEventListener('theme:variant:change', (event) => {
                const subOneTimeBtn = container.querySelector('.rtx-purchase-label--one-time');
                const pdpDiscountWrapper = container.querySelectorAll('[data-pdp-discount-wrapper]');
                
                const discountAmount = (100 - theme.settings.discountAmount) / 100;

                const originalPrice = (event.detail.variant.price / 100);
                let variantPrice = originalPrice.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
                let discountPrice = (originalPrice * discountAmount).toLocaleString('en-US', {style: 'currency', currency: 'USD'});

                variantPrice = variantPrice.replace(/\.00$/, '');
                discountPrice = discountPrice.replace(/\.00$/, '');

                if(subOneTimeBtn && !subOneTimeBtn.classList.contains('is-selected')) {
                    subOneTimeBtn.click();
                }

                pdpDiscountWrapper.forEach(wrapper => {
                    const oneTimeEl = wrapper.querySelector('[data-one-time-price]');
                    const discountEl = wrapper.querySelector('[data-discount-price]');
                    if(oneTimeEl) oneTimeEl.innerText = variantPrice;
                    if(discountEl) discountEl.innerText = discountPrice;
                })
            });
            container.dataset.variantListenerAdded = 'true';
        }
    }
}

const initProductPageDiscount = () => {
    const container = document.querySelector('[data-section-type="product"]');
    if(!container) return;
    
    const productTitle = theme.settings.productTitle;
    initializeDiscountLogic(container, productTitle);
}

const initQuickAddDiscount = () => {
    const modals = document.querySelectorAll('[data-quick-add-modal]:not([data-discount-initialized])');
    
    modals.forEach(modal => {
        const productTitleEl = modal.querySelector('.product__title');
        if(!productTitleEl) return;
        
        const productTitle = productTitleEl.innerText;
        initializeDiscountLogic(modal, productTitle);
    });
}

document.addEventListener("DOMContentLoaded", initProductPageDiscount);
document.addEventListener('shopify:section:load', initProductPageDiscount);
document.addEventListener('theme:quick-add:open', initQuickAddDiscount);